import { IUser } from '@interfaces/IUser';
import { IAppState } from '@myStore/app.state';
import { LoginSuccess, Refresh } from '@myStore/auth/auth.actions';
import { SubscribeToNotifications } from '@myStore/notifications/notifications.actions';
import { GetProfileRequest } from '@myStore/profile-view/profile-view.actions';
import { selectProfile } from '@myStore/profile-view/profile-view.selector';
import { GetUnconfirmedCount } from '@myStore/users/user.actions';
import { select, Store } from '@ngrx/store';
import { AuthService } from '@services/auth/auth.service';
import jwt_decode from 'jwt-decode';

export function initApplication(
  store: Store<IAppState>,
  authService: AuthService
): () => void {
  return () =>
    new Promise(resolve => {
      const accessToken = authService.getToken('access');
      const refreshToken = authService.getToken('refresh');

      if (!refreshToken) {
        resolve(true);
        return;
      }

      if (accessToken) {
        const user: IUser = jwt_decode(accessToken);

        if (authService.tokenIsExpiry(accessToken)) {
          store.dispatch(new Refresh());
        }

        if (user.user_id) store.dispatch(new GetProfileRequest(+user.user_id));
      }

      const profileSub = store
        .pipe(select(selectProfile))
        .subscribe(profile => {
          if (profile && profile.id) {
            store.dispatch(new SubscribeToNotifications(profile.id));

            store.dispatch(new LoginSuccess(profile));

            if (profile.groups?.includes('admins') || profile.is_superuser) {
              store.dispatch(new GetUnconfirmedCount());
            }

            profileSub.unsubscribe();
            resolve(true);
          }
        });
    });
}
